import { AwardCount } from "@hubcapp/types";
import { Box, Button, Typography, colors, makeStyles } from "@material-ui/core";
import AwardRow from "./AwardRow";
import React, { useState } from "react";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  title: {
    padding: theme.spacing(0),
    marginBottom: theme.spacing(2),
  },
  subTitle: {
    fontWeight: 300,
    fontSize: "15px",
    lineHeight: "150%",
  },
  button: {
    textTransform: "none",
    fontWeight: 300,
  },
  separator: {
    borderBottom: `1px solid ${colors.grey[200]}`,
    margin: theme.spacing(2, 0, 4),
  },
}));

const AwardsList: React.FC<{
  topAwards: AwardCount[];
  remainingAwards: AwardCount[];
}> = ({ topAwards, remainingAwards }) => {
  const classes = useStyles();
  const [showAll, setShowAll] = useState(false);

  return (
    <>
      <Box>
        {topAwards.map(a => (
          <AwardRow
            award={a.award}
            supportersCount={a.count ?? 0}
            key={a.count}
          />
        ))}
      </Box>

      {showAll ? (
        <Box>
          {topAwards.length > 0 ? <Box className={classes.separator} /> : null}

          <Typography
            variant="h3"
            color="textPrimary"
            className={clsx(classes.subTitle, classes.title)}
          >
            The following awards will not be visible on your public business
            profile:
          </Typography>

          {remainingAwards.map(a => (
            <AwardRow
              award={a.award}
              supportersCount={a.count ?? 0}
              key={a.award}
            />
          ))}
        </Box>
      ) : (
        <Box display="flex" justifyContent="center" width="100%">
          <Button
            variant="text"
            color="primary"
            onClick={() => setShowAll(!showAll)}
            className={classes.button}
          >
            {topAwards.length > 0 ? "View all" : "View awards"}
          </Button>
        </Box>
      )}
    </>
  );
};
export default AwardsList;
